import React, { useState } from 'react';
import Loading from "../components/LoadingComponent/Loading"
import { appDataLoad } from '../store/AppData/AppData';
import { actCartLoad, actLoading, actLoadingEnd } from '../store/Actions';
import { commonLoadLocations } from '../store/LoaderCommons/LoaderCommons';
import HeaderAlert from '../components/HeaderAlertComponent/HeaderAlert';
import { credentialLoad, ordersLoad } from '../store/UserData/UserData';
import { AppRoute } from './AppRoute';
import { useLocation } from "react-router-dom";
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';
import LocalDataStore from '../common/LocalDataStore';
import Helpers from '../common/Helpers';
import log from "loglevel";
import { Version } from '../common/Conf';
import { remoteLogDatadog } from '../common/RemoteLogDatadog';
import FooterMain from './FooterMain';
import NavigationMenu from './NavigationMenu';
import HeaderPage from './HeaderPage';
import { appConfLoad } from '../store/AppConf/AppConf';
import { useAppDispatch, useAppSelector } from '../store/hooks';

export default function App() {
    const dispatch = useAppDispatch()
    const dics = useAppSelector((state) => state.dics)
    const appConf = useAppSelector((state) => state.appConf)
    const userData = useAppSelector((state) => state.userData)
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    React.useEffect(() => {
        appConfLoad(dispatch)
        serviceWorkerRegistration.register({
            onUpdate: (registration) => {
                appRefreshAndUpdate()
            },
        });
        let locationCode = LocalDataStore.locationGet()
        if (locationCode === '') {
            locationCode = Helpers.LocationFromPath(location.pathname)
            if (locationCode !== '')
                LocalDataStore.locationSet(locationCode)
        }
        (async function () {
            actLoading(dispatch)
            credentialLoad(userData, dispatch)
            actCartLoad(dispatch);
            // locationDefatult used for the first time load the app. 
            const locationDefault = await commonLoadLocations(dics.locations, dispatch)
            if (locationCode !== '')
                await appDataLoad(locationCode, dispatch)
            else if (locationDefault)
                await appDataLoad(locationDefault, dispatch)

            await ordersLoad(dispatch)
            setLoading(false)
            actLoadingEnd(dispatch)
        })();

        remoteLogDatadog(log)
        log.setLevel("INFO")
        log.info("App " + Version);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function appRefreshAndUpdate() {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker
                .getRegistration()
                .then((reg: any) => {
                    reg.waiting.postMessage({ type: 'SKIP_WAITING' });
                    window.location.reload();
                })
                .catch((err) => console.log('Could not get registration: ', err));
        }
    }

    return (<>
        <Loading />
        <div className="app" id="app">
            <main>
                <HeaderAlert />
                <HeaderPage instanceCode={appConf.iCl} />
                {!loading && AppRoute()}
            </main>
            <FooterMain instanceCode={appConf.iCl}/>
        </div>
        <NavigationMenu />
    </>
    )
}
